import { render } from "./ResponsiveDataTable.vue?vue&type=template&id=64c5be4c&scoped=true"
import script from "./ResponsiveDataTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveDataTable.vue?vue&type=script&lang=js"

import "./ResponsiveDataTable.vue?vue&type=style&index=0&id=64c5be4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c5be4c"]])

export default __exports__